import { createContext, MutableRefObject } from 'react';
import { EntityFooterConfig } from './types';

export type EntityFooterContextValue = {
  configRef: MutableRefObject<EntityFooterConfig | null>;
  subscribe: (callback: () => void) => () => void;
  notify: () => void;
};

export const EntityFooterContext = createContext<EntityFooterContextValue | null>(null);
